/**
 * Created by Arif Topcu in 2019
 */

import Checkbox from "@ls/react-checkbox";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEnableAsOfDate } from "state/misc/actions";
import { selectEnableAsOfDate } from "state/misc/selectors";
import SelectionState from "state/selections/SelectionState";
import styled from "styled-components";

const Item = styled.div`
  padding: 5px;
  margin: 0 0 5px 0;
  background: #bfbfbf;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  border: 1px solid #a2a2a2;
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
`;

const AsOfDate = (props) => {
  const dispatch = useDispatch();
  const enableAsOfDate = useSelector(
    selectEnableAsOfDate(SelectionState.UNCOMMITTED)
  );
  const onChange = React.useCallback(
    (val) => dispatch(setEnableAsOfDate(val)),
    [dispatch]
  );
  return (
    <Item>
      <Checkbox
        label={"As of Date"}
        value={enableAsOfDate}
        onChange={onChange}
      />
    </Item>
  );
};

export default AsOfDate;
